import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class FoodGroupService {

  constructor() { }

  /**
   * Establece los colores para las categorías
   * @param categoryName nombre de la categoría
   * @returns color en hexadecimal
   */
  setIngredientCategoryColor(categoryName: string): string {
    let color = '';
    switch (categoryName) {
      case 'Verduras':
        color = '#BDC581';
        break;
      case 'Frutas':
        color = '#D6A2E8';
        break;
      case 'Cereales con grasa':
        color = '#e66767';
        break;
      case 'Cereales sin grasa':
        color = '#778beb';
        break;
      case 'Leguminosas':
        color = '#f7d794';
        break;
      case 'Alimentos de origen animal muy bajo en grasa':
        color = '#f8a5c2';
        break;
      case 'Alimentos de origen animal bajo en grasa':
        color = '#f5cd79';
        break;
      case 'Alimentos de origen animal moderados en grasa':
        color = '#f19066';
        break;
      case 'Alimentos de origen animal alto en grasa':
        color = '#e15f41';
        break;
      case 'Leche descremada':
        color = '#63cdda';
        break;
      case 'Leche semidescremada':
        color = '#63a5da';
        break;
      case 'Leche entera':
        color = '#6372da';
        break;
      case 'Leche con azúcar':
        color = '#cf6a87';
        break;
      case 'Aceites y grasas':
        color = '#c44569';
        break;
      case 'Aceites y grasas con proteina':
        color = '#c55682';
        break;
      case 'Azucares sin grasa':
        color = '#3dc1d3';
        break;
      case 'Azucares con grasa':
        color = '#574b90';
        break;
      case 'Alimentos libres en energía':
        color = '#56c590';
        break;
      case 'Bebidas alcohólicas':
        color = '#cc9a4a';
        break;
    }
    return color;
  }
}
